/**
 * Утилиты для обработки HTML результатов
 * Преобразует относительные пути в абсолютные для корректной работы в dev режиме
 */

/**
 * Преобразует относительные пути к изображениям в HTML в абсолютные
 * @param html - HTML контент результата
 * @param baseUrl - базовый URL (например, https://d1.testometrika.com/)
 * @returns HTML с абсолютными путями
 */
export const processImagePathsInHTML = (html: string, baseUrl: string): string => {
	if (!html || !baseUrl) {
		return html;
	}

	// Удаляем завершающий слеш у baseUrl если есть
	const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

	// Регулярное выражение для поиска относительных путей в src атрибутах
	// Ищем src="/...", src='/...' и src=/...
	const srcPattern = /src=["']?(\/[^"'\s>]+)["']?/gi;

	// Заменяем относительные пути на абсолютные
	const processedHTML = html.replace(srcPattern, (match, path) => {
		// Если путь уже абсолютный (начинается с http:// или https://), не меняем
		if (path.startsWith('http://') || path.startsWith('https://')) {
			return match;
		}

		// Формируем абсолютный путь
		const absolutePath = `${cleanBaseUrl}${path}`;
		
		// Определяем какие кавычки использовались в оригинале
		const quote = match.includes('"') ? '"' : match.includes("'") ? "'" : '';
		
		return `src=${quote}${absolutePath}${quote}`;
	});

	return processedHTML;
};

/**
 * Обрабатывает HTML результата: заменяет относительные пути и выполняет другие преобразования
 * ВАЖНО: Преобразование путей происходит ТОЛЬКО в DEV режиме!
 * В production относительные пути остаются относительными.
 * 
 * @param html - HTML контент результата
 * @returns обработанный HTML
 */
export const processResultHTML = (html: string): string => {
	if (!html) {
		return html;
	}

	// ВАЖНО: Преобразуем пути только в DEV режиме
	// В production фронтенд и бэкенд на одном домене, относительные пути работают корректно
	if (!import.meta.env.DEV) {
		return html;
	}

	// Получаем BASE_URL из переменных окружения
	const baseUrl = import.meta.env.VITE_HOST || '';

	// Обрабатываем пути к изображениям только в DEV
	let processedHTML = processImagePathsInHTML(html, baseUrl);

	// Здесь можно добавить другие преобразования если понадобится
	// Например, обработку ссылок, видео и т.д.

	return processedHTML;
};
